import { GENERIC_ERROR_MESSAGE } from './constants'

interface ApiErrorBody {
  message?: unknown
  error?: unknown
}

interface ErrorLike {
  message?: unknown
  response?: {
    data?: ApiErrorBody
  }
}

const asErrorString = (value: unknown): string | null => {
  if (typeof value === 'string' && value.trim()) {
    return value
  }
  return null
}

/**
 * Normalizes axios / unknown errors into a user-facing string.
 */
export const getApiErrorMessage = (error: unknown): string => {
  if (!error || typeof error !== 'object') {
    return GENERIC_ERROR_MESSAGE
  }

  const errorLike = error as ErrorLike
  const body = errorLike.response?.data

  return (
    asErrorString(body?.message) ||
    asErrorString(body?.error) ||
    asErrorString(errorLike.message) ||
    GENERIC_ERROR_MESSAGE
  )
}
